import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const ContentWrapper = styled.div`
	display: grid;
	grid-template-columns: 274px 1fr;
	margin-top: 54px;
	column-gap: 29px;
	${media.tablet} {
		grid-template-columns: 1fr;
		margin-top: 24px;
	}
	${media.mobile} {
		margin-top: 34px;
	}
`;

export const CatalogueSubtitleStyles = css`
	display: block;
	margin-top: 16px;
	${media.laptop} {
		width: 760px;
	}
	${media.tablet} {
		width: 600px;
	}
	${media.mobile} {
		width: 100%;
	}
`;
